import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";

const RenewalTopUpValidation = () => {
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);

  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);

  const columns = [
    { id: "index", label: "S.No" },
    { id: "source", label: "Source" },
    { id: "type", label: "Type" },
    { id: "enabled", label: "Enabled" },
    { id: "auditedPacketEnabled", label: "Audited Packet Enabled" },
    { id: "legalMarkingEnabled", label: "Legal Marking Enabled" },
    { id: "maxEligibleDaysBeforeMaturity", label: "Max Eligible Days" },
    { id: "thresholdLtv", label: "Threshold LTV (%)" },
    { id: "lockInPeriod", label: "Lock-in Period" },
    { id: "loanPercentage", label: "Loan Percentage (%)" },
    { id: "action", label: "Action" },
  ];

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.RENEWAL_TOP_UP_VALIDATION_FINDALL,
      authToken,
    });
    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res.data.user_description, true);
    } else {
      setRawData(res?.data || []);
      parseTableData(res?.data || []);
    }
  };

  const parseTableData = (data) => {
    const tableData = data.map((item, index) => ({
      index: index + 1,
      source: item.source,
      type: item.type,
      enabled: item.enabled ? "Yes" : "No",
      auditedPacketEnabled: item.auditedPacketEnabled ? "Yes" : "No",
      legalMarkingEnabled: item.legalMarkingEnabled ? "Yes" : "No",
      maxEligibleDaysBeforeMaturity: item.maxEligibleDaysBeforeMaturity,
      thresholdLtv: item.thresholdLtv,
      lockInPeriod: item.lockInPeriod,
      loanPercentage: item.loanPercentage,
      action: getIcons(item.id),
    }));

    setSelectedTableData(tableData);
  };

  const getIcons = (id) => (
    <IconButton onClick={() => onEdit(id)}>
      <EditIcon />
    </IconButton>
  );

  const onEdit = (id) => {
    navigate(`/coreservice/renewalTopUpValidation-create/${id}`);
  };

  const onSearchChange = (event) => {
    const val = event.target.value.toLowerCase();
    const filtered = rawData.filter((row) =>
      row.type?.toLowerCase().includes(val)
    );
    parseTableData(filtered);
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <SubHeader
          label="Renewal / Top-Up Validation"
          search
          searchLabel="Search by Type"
          onSearchChange={onSearchChange}
        />
      </GridItem>

      <GridItem xs={12}>
        <ColumnGroupingTable columns={columns} rows={selectedTableData} />
      </GridItem>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress />}
    </GridContainer>
  );
};

export default RenewalTopUpValidation;
